/* eslint-disable */
import { AxiosError, AxiosRequestConfig, isAxiosError } from "axios";
import { UBA_EVENT_NAMES } from "@/constants/UbaConstants";

type PageViewPayload = Record<string, any>;

interface TrackingData {
  eventName: string;
  keyNames: {
    [key: string]: any;
  };
}

type CtaClickPayload = Record<string, any>;

type MainParams = Record<string, any>;

type KeyNames = Record<string, any>;

export enum EErrorLevel {
  LOW = "low",
  MEDIUM = "medium",
  HIGH = "high",
  CRITICAL = "critical",
}

export enum EErrorSource {
  API = "api",
  ZOOM = "zoom",
  WEBSOCKET = "websocket",
  EXCEPTION = "exception",
  BROWSER_PERMISSION = "browser_permission",
  REALTIME_ALERT = "realtime_alert",
  MEDIA_DEVICES = "media_devices",
  MULTIPLE_TAB = "multiple_tab",
  SERVER_TIME = "server_time",
  SYSTEM_CHECK = "system_check",
}

export enum EInfoSource {
  API = "api",
  BROWSER_PERMISSION = "browser_permission",
  DOSELECT_MONACO_EDITOR = "doselect_monaco_editor",
  EXCEPTION = "exception",
  LOCAL_VIDEO_STREAM = "local_video_stream",
  REDIRECTION = "redirection",
  SCREEN_SHARE = "SCREEN_SHARE",
  WEBSOCKET = "websocket",
  ZOOM = "zoom",
  REALTIME_ALERT = "realtime_alert",
  MEDIA_DEVICES = "media_devices",
  MULTIPLE_TAB = "multiple_tab",
  SERVER_TIME = "server_time",
  SYSTEM_CHECK = "system_check",
}

export const initTracking = (
  mainParams: MainParams = {},
  keyNames: KeyNames = {},
) => {
  const defaultKeyNames: KeyNames = {};
  (window as any).tracking.init(
    { ...defaultKeyNames, ...keyNames },
    mainParams,
  );
};

export const doTracking = (ubaTrackingData: any) => {
  const payload = { uba: ubaTrackingData || { keyNames: {} } };
  (window as any).tracking.doTracking(payload);
};

// example of one uba util function like view
export const view = (
  eventName: string,
  { ...payload }: PageViewPayload = {},
) => {
  const trackingData: TrackingData = {
    eventName,
    keyNames: {
      ...payload,
    },
  };

  doTracking(trackingData);
};

export const ctaClick = (
  eventName: string,
  { ...payload }: CtaClickPayload = {},
) => {
  const trackingData: TrackingData = {
    eventName,
    keyNames: {
      ...payload,
    },
  };

  doTracking(trackingData);
};

export const errorLogger = (
  error: AxiosError | Error,
  level: EErrorLevel,
  source: EErrorSource,
  payload: any = {},
  errorInfo: any = {},
) => {
  const enableLogger = JSON.parse(
    localStorage.getItem("enableLogger") ?? "false",
  ) as boolean;
  if (process.env.NODE_ENV === "development" || enableLogger) {
    console.log(`Error - level: ${level}, source: ${source}`, {
      error,
      payload,
      errorInfo,
    });
  }
  const trackingData = {
    eventName: UBA_EVENT_NAMES.errorLog,
    keyNames: {
      errorMessage: error?.message,
      errorSource: source,
      errorName: error?.name,
      errorLevel: level,
      payload: payload ? JSON.stringify(payload) : "",
      extraData: JSON.stringify({ stack: error.stack || error, errorInfo }),
    },
  };
  if (isAxiosError(error)) {
    trackingData.keyNames.errorMessage = error.response?.data.message;
    trackingData.keyNames.extraData = JSON.stringify({
      statusCode: error.response?.status,
      url: error.config?.url,
    });
  }
  doTracking(trackingData);
};

export const infoLogger = (
  message: string,
  source: EInfoSource,
  extraData: any = {},
  payload: any = {},
  statusCode: string = "",
) => {
  const enableLogger = JSON.parse(
    localStorage.getItem("enableLogger") ?? "false",
  ) as boolean;
  if (process.env.NODE_ENV === "development" || enableLogger) {
    console.log(message, source, extraData, payload);
  }
  const trackingData = {
    eventName: UBA_EVENT_NAMES.log,
    keyNames: {
      message: message,
      source: source,
      payload: payload ? JSON.stringify(payload) : "",
      statusCode: statusCode,
      extraData: JSON.stringify(extraData),
    },
  };
  doTracking(trackingData);
};
